import axios from 'axios';

// export const API_BASE_URL = 'https://api.opticflow.pk';  // ← no trailing slash
export const API_BASE_URL = import.meta.env.VITE_API_BASE?.replace(/^http:\/\//, 'https://') || 'https://api.opticflow.pk';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) throw new Error('No refresh token');

        const response = await axios.post(`${API_BASE_URL}/api/token/refresh/`, {
          refresh: refreshToken,
        });

        const newAccessToken = response.data.access;
        localStorage.setItem('access_token', newAccessToken);
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (err) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

// Auth helpers — export these for use in login page
export const loginUser = async (username, password) => {
  const response = await axios.post(`${API_BASE_URL}/api/token/`, {
    username,
    password,
  });
  return response.data; // { access, refresh }
};

export const getDashboardStats = async () => {
  try {
    const [customers, invoices, collections] = await Promise.all([
      api.get('/customers/'),
      api.get('/invoices/'),
      api.get('/collections/?limit=10'),
    ]);
    return {
      customers: customers.data.results,
      invoices: invoices.data.results,
      collections: collections.data.results,
    };
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};


export const getExpiredCustomersThisMonth = async () => {
  try {
    const response = await api.get('/admin/dashboard-analytics/?period=overview'); // payload contains expired_this_month
    return response.data.expired_this_month;
  } catch (error) {
    console.error('Error fetching expired customers this month:', error);
    throw error;
  }
};

export default api;
